import { useRef, useState } from 'react';
import { Button } from '@chakra-ui/react';
import { MdUploadFile } from 'react-icons/md';
import api from '@services/api';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';

const ImportButton = () => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  
  const [loading, setLoading] = useState(false);

  const onFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const csvFile = event.target.files?.[0];
    if (!csvFile) return;

    setLoading(true);

    const formData = new FormData();
    formData.append('csvFile', csvFile);

    try {
      const response = await api.post('/customer/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.errors) {
        toast.error('Erro ao importar clientes. Verifique o arquivo e tente novamente.');
      } else {
        window.location.reload();
      }
    } catch (error) {
      toast.error('Erro ao importar clientes. Tente novamente!');
      datadogRum.addError(new Error('Fail to import customers'), {
        error,
      });
    } finally {
      setLoading(false);
    }
  };

  const onImportClick = () => {
    fileInputRef.current?.click();
  };
  
  return (
    <>
      <Button size="sm" onClick={onImportClick} loading={loading}>
        <MdUploadFile /> Importar
      </Button>
      <input
        type="file"
        accept=".xls,.xlsx,.csv"
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={onFileChange}
      />
    </>
  );
};

export default ImportButton;